import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined'
import ProgressBar from './ProgressBar';
import TranslationContent_IEP from './TranslationContents/TranslationContent_IEP'
import TranslationContent_Transcript from './TranslationContents/TranslationContent_Transcript'
import TranslationContent_Letter from './TranslationContents/TranslationContent_Letter'
import TranslationContent_SchoolDocument from './TranslationContents/TranslationContent_SchoolDocument'
import TranslationContent_Evaluations from './TranslationContents/TranslationContent_Evaluations'
import TranslationContent_Other from './TranslationContents/TranslationContent_Other'
import NavBottom_Call_Mail_Youtube from './NavBottom_Call_Mail_Youtube'
import MultipleSelect_Checkbox from './MultiSelect_Checkbox'
import Dropdown_Advanced from './Dropdown_Advanced'
import TextFields_Outlined_Phone from './TextMasks/TextMask_Phone'
import MySectionBlock from './MySectionBlock'
import ValidationModal from './ValidationModal';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

/* Button */
import Button from '@material-ui/core/Button';
/* Grid */
import Grid from '@material-ui/core/Grid';
import { createTheme, ThemeProvider  } from "@material-ui/core";
/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import districts from '../data/districts.json'
import schools from '../data/schools.json'
import grades from '../data/grades.json'
import genders from '../data/genders.json'

import ColumnStatus from './ColumnStatus'

/* Bottom Nav */


/* Context */
import ContentContext from './ContentContext'
import { TranslationColumn1Context } from './TranslationContexts/TranslationColumn1Context'
import { useDispatch, useSelector } from 'react-redux'
import { studentFirstName_bilUpdated, studentLastName_bilUpdated, countryOfOrigin_bilUpdated, DOB_bilUpdated, gender_bilUpdated, yearsInUS_bilUpdated, grade_bilUpdated, childResidesWith_bilUpdated, mfg1_bilUpdated, mfgName1_bilUpdated, mfg2_bilUpdated, mfgName2_bilUpdated, childsResidesWithOther_bilUpdated, homeAddress_bilUpdated, homeNum_bilUpdated, workNum_bilUpdated, cellNum_bilUpdated, nativeLanguage_bilUpdated, nativeLanguageOther_bilUpdated, districtDropdown_bilUpdated, schoolDropdown_bilUpdated, CSEDate_bilUpdated, currentTeacherName_bilUpdated, currentTeacherEmail_bilUpdated, psychologistName_bilUpdated, psychologistEmail_bilUpdated, speechPathologistName_bilUpdated, speechPathologistEmail_bilUpdated, districtContactName_bilUpdated, districtContactTitle_bilUpdated, districtContactAddress_bilUpdated, districtContactPhone_bilUpdated, districtContactEmail_bilUpdated, approverName_bilUpdated, approverTitle_bilUpdated, approverEmail_bilUpdated, coser_bilUpdated, reason_bilUpdated, alreadyClassified_bilUpdated, classification_bilUpdated, consentToEvalAttached_billUpdated, priorWrittenNoticeAttached_bilUpdated, homeLangQuestAttached_bilUpdated, nonVerbSecDiagnosed_bilUpdated, studentEnterSchoolDate_bilUpdated, nameOfOtherSchoolAttended_bilUpdated, typesOfEvals_bilUpdated, typesOfEvals_other_bilUpdated, diagnosedCondition_bilUpdated, diagnosedConditionText_bilUpdated, services_bilUpdated, generalHealth_bilUpdated, generalHealthText_bilUpdated, medication_bilUpdated, medicationText_bilUpdated, wearsGlasses_bilUpdated, wearsGlassesText_bilUpdated, pedRestrictions_bilUpdated, pedRestrictionsText_bilUpdated, physicalExamDate_bilUpdated, h_freq_audiology_bilUpdated, h_indv_audiology_bilUpdated, h_freq_visTherapy_bilUpdated, h_indv_visTherapy_bilUpdated, h_freq_resourceRoom_bilUpdated, h_indv_resourceRoom_bilUpdated, h_freq_counseling_bilUpdated, h_indv_counseling_bilUpdated, h_freq_speechLang_bilUpdated, h_indv_speechLang_bilUpdated, h_freq_physTherapy_bilUpdated, h_indv_physTherapy_bilUpdated, h_freq_occTherapy_bilUpdated, h_indv_occTherapy_bilUpdated, i_freq_Reading_bilUpdated, i_indv_Reading_bilUpdated, i_freq_AISMath_bilUpdated, i_indv_AISMath_bilUpdated, i_freq_AAtL_bilUpdated, i_indv_AAtL_bilUpdated, i_freq_AdjAssign_bilUpdated, i_indv_AdjAssign_bilUpdated, i_freq_schedAdj_bilUpdated, i_indv_schedAdj_bilUpdated, i_freq_indvProgBasedOnSkill_bilUpdated, i_indv_indvProgBasedOnSkill_bilUpdated, i_freq_speechImprov_bilUpdated, i_indv_speechImprov_bilUpdated, i_freq_tutoring_bilUpdated, i_indv_tutoring_bilUpdated, i_freq_consulServices_bilUpdated, i_indv_consulServices_bilUpdated, i_other_bilUpdated, areas_bilUpdated, addConcerns_bilUpdated, suspDetails_bilUpdated, notes_bilUpdated, docToAccessFiles_bilUpdated, consentToEvalAttachedFiles_bilUpdated, priorWrittenNoticeAttachedFiles_bilUpdated, homeLangQuestAttachedFiles_bilUpdated } from '../redux/slices/assessmentSlice'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import MultipleSelect from './MultiSelect_Checkbox';

/* Accordion */
import Directions_Accordion from './Directions_Accordion'
/* Date Picker */
import DatePicker_Simple from './DatePicker_Simple'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FcCalendar } from 'react-icons/fc';

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import Checkbox_Regular from './Checkbox_Regular';
import { red } from '@material-ui/core/colors';
import TextFields_Outlined_Long from './TextFields_Outlined_Long';


const BilingualAssessmentContent = ({ handleContinueButton, handleProgressBarChange }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  //const { dataContext, setDataContext } = useContext(TranslationDataContext)

  const dispatch = useDispatch();
  const assessmentState = useSelector((state) => state.assessment); // Access translation state
  const [progressBarClass, setProgressBarClass] = useState('')

  const dataForQB = useTranslation()
  const setDataForQB = useTranslationUpdate()
  //const { dataForQB, setDataForQB } = useContext(TranslationDataContext)
  //alert(dataForQB.dueDateText+"data for qb")

  const useStyles = createTheme((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  //const classes = makeStyles();

  //////////////////////////////////////////////////////////////
  // COLUMN VALIDATION - UI TO SHOW THIS
  //////////////////////////////////////////////////////////////

  const updateNonRequireField = (id, valueInInput) =>{
    dataForQB[id] = valueInInput
  }

  //////////////////////////////////////////////////////////////
  // Column 1
  //////////////////////////////////////////////////////////////
  const [translationTypes, setTranslationTypes] = useState(''); // new one for multi-select
  const handleTranslationTypeChanges = (selectedTypes) => {
    setTranslationTypes(selectedTypes);
  }
  const [col1RequiredFields, setCol1RequiredFields] = useState({})
  const [column1Complete, setColumn1Complete] = useState(false)
  const updateColumn1Count = (id, valueInInput) => {
    let allFilledOut = true;
    for (var key in col1RequiredFields) {
      //console.log("key " + key + " has value " + col1RequiredFields[key]);
      if (key == id) {
        col1RequiredFields[key] = valueInInput
        // Set the POST obj
        dataForQB[key] = valueInInput;
      }
      if (col1RequiredFields[key] == "") {
        allFilledOut = false;
      }
      
    }
    setColumn1Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn1ColumnStatus = () => {
    return <ColumnStatus complete={column2Complete} />
  }
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 2
  //////////////////////////////////////////////////////////////
  // States
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [column2Complete, setColumn2Complete] = useState(false)
  const [renderOtherLang, setRenderOtherLang] = useState(false)
  const [col2RequiredFields, setCol2RequiredFields] = useState(
    {
      CSEDate_bil: '',
      psychologistName_bil: '',
      psychologistEmail_bil: '',
      speechPathologistName_bil: '',
      speechPathologistEmail_bil: '',
      districtContactName_bil: '',
      districtContactTitle_bil: '',
      districtContactAddress_bil: '',
      districtContactPhone_bil: '',
      districtContactEmail_bil: '',
      approverName_bil: '',
      approverTitle_bil: '',
      approverEmail_bil: ''
    }
  )

  const updateColumn2Count = (id, valueInInput) => {
    col2RequiredFields["CSEDate_bil"] = dataForQB.CSEDate_bil;
    col2RequiredFields["psychologistName_bil"] = dataForQB.psychologistName_bil;
    col2RequiredFields["psychologistEmail_bil"] = dataForQB.psychologistEmail_bil;
    col2RequiredFields["speechPathologistName_bil"] = dataForQB.speechPathologistName_bil;
    col2RequiredFields["speechPathologistEmail_bil"] = dataForQB.speechPathologistEmail_bil;
    col2RequiredFields["districtContactName_bil"] = dataForQB.districtContactName_bil;
    col2RequiredFields["districtContactTitle_bil"] = dataForQB.districtContactTitle_bil;
    col2RequiredFields["districtContactAddress_bil"] = dataForQB.districtContactAddress_bil;
    col2RequiredFields["districtContactPhone_bil"] = dataForQB.districtContactPhone_bil;
    col2RequiredFields["districtContactEmail_bil"] = dataForQB.districtContactEmail_bil;
    col2RequiredFields["approverName_bil"] = dataForQB.approverName_bil;
    col2RequiredFields["approverTitle_bil"] = dataForQB.approverTitle_bil;
    col2RequiredFields["approverEmail_bil"] = dataForQB.approverEmail_bil;
    let allFilledOut = true;
    for (var key in col2RequiredFields) {
      //console.log("key " + key + " has value " + col2RequiredFields[key]);
      if (key == id) {
        col2RequiredFields[key] = valueInInput
        // Set the POST obj
      dataForQB[key] = valueInInput;
      }
      if (col2RequiredFields[key] == "") {
        allFilledOut = false;
      }
      
    }
    if (id == "districtDropdown") {
      setCurrentDistrict(valueInInput)
      //setCurrentDistrict("Babylon")
    }
    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn2ColumnStatus = () => {
    return <ColumnStatus complete={column2Complete} />
  }
  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }
  

  //const progressBarData = { bgcolor: "#00695c", completed: 0 }
  //const [progressBarPercent, setProgressBarPercent] = useState(0)

  function backToPreviousScreen(){
    dataForQB.assessmentRunOnce = false;
    handleThisContinueButton("main")
  }


  const setProgressBarDataInParent = () => {
    let temp = 0;
    if (col2RequiredFields.CSEDate_bil != "") temp += 8;
    if (col2RequiredFields.psychologistName_bil != "") temp += 8;
    if (col2RequiredFields.psychologistEmail_bil != "") temp += 8;
    if (col2RequiredFields.speechPathologistName_bil != "") temp += 8;
    if (col2RequiredFields.speechPathologistEmail_bil != "") temp += 8;
    if (col2RequiredFields.districtContactName_bil != "") temp += 8;
    if (col2RequiredFields.districtContactTitle_bil != "") temp += 8;
    if (col2RequiredFields.districtContactAddress_bil != "") temp += 8;
    if (col2RequiredFields.districtContactPhone_bil != "") temp += 8;
    if (col2RequiredFields.districtContactEmail_bil != "") temp += 7;
    if (col2RequiredFields.approverName_bil != "") temp += 7;
    if (col2RequiredFields.approverTitle_bil != "") temp += 7;
    if (col2RequiredFields.approverEmail_bil != "") temp += 7;
    handleProgressBarChange(parseInt(temp))
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete, column2Complete]);

  //////////////////////////////////////////////////////////////
  //  Due Date
  //////////////////////////////////////////////////////////////
  const [startDueDate, setStartDueDate] = useState('')
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Validations
  //////////////////////////////////////////////////////////////approver email
  const [validate_districtPhone, setValidation_districtPhone] = useState('')
  const [validate_psychologistEmail, setValidation_psychologistEmail] = useState('')
  const [validate_speechPathologistEmail, setValidation_speechPathologistEmail] = useState('')
  const [validate_currentTeacherEmail, setValidate_currentTeacherEmail] = useState('')
  const [validate_districtContactEmail, setValidation_districtContactEmail] = useState('')
  const [validate_approverEmail, setValidation_approverEmail] = useState('')

  // Validation Modal State
  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [validationModalMissingFields, setValidationModalMissingFields] = useState([]);
  const [validationModalErrors, setValidationModalErrors] = useState([]);

  // Solution 1: Detect autofill and sync values to state
  useEffect(() => {
    // Define which fields belong to this page
    const validFieldsForThisPage = [
      'CSEDate_bil',
      'currentTeacherName_bil',
      'currentTeacherEmail_bil',
      'psychologistName_bil',
      'psychologistEmail_bil',
      'speechPathologistName_bil',
      'speechPathologistEmail_bil',
      'districtContactName_bil',
      'districtContactTitle_bil',
      'districtContactAddress_bil',
      'districtContactPhone_bil',
      'districtContactEmail_bil',
      'approverName_bil',
      'approverTitle_bil',
      'approverEmail_bil'
    ];

    const detectAndSyncAutofill = () => {
      const inputs = document.querySelectorAll('input, textarea, select');
      let autofillDetected = false;

      inputs.forEach((input) => {
        // Skip MUI internal elements
        if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
          return;
        }

        // Only process fields that belong to this page
        if (!validFieldsForThisPage.includes(input.id)) {
          return;
        }

        if (input.value && input.id) {
          const stateValue = dataForQB[input.id];

          if (!stateValue || stateValue !== input.value) {
            autofillDetected = true;
            console.log(`Autofill detected for field: ${input.id}`);
            mapToRedux(input.id, input.value);
            updateColumn2Count(input.id, input.value);
          }
        }
      });

      if (autofillDetected) {
        console.log('Autofill detected on Page 2, revalidating form...');
        setTimeout(() => {
          updateColumn2Count();
        }, 100);
      }
    };

    const timer1 = setTimeout(detectAndSyncAutofill, 500);
    const timer2 = setTimeout(detectAndSyncAutofill, 1000);
    const timer3 = setTimeout(detectAndSyncAutofill, 2000);

    const handleInputEvent = (e) => {
      // Skip MUI internal elements
      if (!e.target.id || e.target.id.startsWith('mui-') || e.target.id.startsWith('react-select-')) {
        return;
      }

      // Only process fields that belong to this page
      if (!validFieldsForThisPage.includes(e.target.id)) {
        return;
      }

      if (e.target.id && e.target.value) {
        mapToRedux(e.target.id, e.target.value);
        updateColumn2Count(e.target.id, e.target.value);
      }
    };

    const inputs = document.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      input.addEventListener('input', handleInputEvent);
    });

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      inputs.forEach(input => {
        input.removeEventListener('input', handleInputEvent);
      });
    };
  }, []);

  // Solution 3: Get list of missing required fields - check Redux state only
  const getMissingRequiredFields = () => {
    const missingFields = [];

    if (!assessmentState.CSEDate_bil || assessmentState.CSEDate_bil === '') {
      missingFields.push('CSE Meeting Date');
    }

    if (!assessmentState.psychologistName_bil || assessmentState.psychologistName_bil === '') {
      missingFields.push('Psychologist Name');
    }

    if (!assessmentState.psychologistEmail_bil || assessmentState.psychologistEmail_bil === '') {
      missingFields.push('Psychologist Email');
    }

    if (!assessmentState.speechPathologistName_bil || assessmentState.speechPathologistName_bil === '') {
      missingFields.push('Speech Pathologist Name');
    }

    if (!assessmentState.speechPathologistEmail_bil || assessmentState.speechPathologistEmail_bil === '') {
      missingFields.push('Speech Pathologist Email');
    }

    if (!assessmentState.districtContactName_bil || assessmentState.districtContactName_bil === '') {
      missingFields.push('District Contact Name');
    }

    if (!assessmentState.districtContactTitle_bil || assessmentState.districtContactTitle_bil === '') {
      missingFields.push('District Contact Title');
    }

    if (!assessmentState.districtContactAddress_bil || assessmentState.districtContactAddress_bil === '') {
      missingFields.push('District Contact Address');
    }

    if (!assessmentState.districtContactPhone_bil || assessmentState.districtContactPhone_bil === '') {
      missingFields.push('District Contact Phone');
    }

    if (!assessmentState.districtContactEmail_bil || assessmentState.districtContactEmail_bil === '') {
      missingFields.push('District Contact Email');
    }

    if (!assessmentState.approverName_bil || assessmentState.approverName_bil === '') {
      missingFields.push('Approver Name');
    }

    if (!assessmentState.approverTitle_bil || assessmentState.approverTitle_bil === '') {
      missingFields.push('Approver Title');
    }

    if (!assessmentState.approverEmail_bil || assessmentState.approverEmail_bil === '') {
      missingFields.push('Approver Email');
    }

    return missingFields;
  };

  // Solution 3: Sync DOM values before validation
  const syncDOMValuesToState = () => {
    // Define which fields belong to this page
    const validFieldsForThisPage = [
      'CSEDate_bil',
      'currentTeacherName_bil',
      'currentTeacherEmail_bil',
      'psychologistName_bil',
      'psychologistEmail_bil',
      'speechPathologistName_bil',
      'speechPathologistEmail_bil',
      'districtContactName_bil',
      'districtContactTitle_bil',
      'districtContactAddress_bil',
      'districtContactPhone_bil',
      'districtContactEmail_bil',
      'approverName_bil',
      'approverTitle_bil',
      'approverEmail_bil'
    ];

    const inputs = document.querySelectorAll('input, textarea, select');
    let syncedCount = 0;

    inputs.forEach((input) => {
      // Skip MUI internal elements
      if (!input.id || input.id.startsWith('mui-') || input.id.startsWith('react-select-')) {
        return;
      }

      // Only process fields that belong to this page
      if (!validFieldsForThisPage.includes(input.id)) {
        return;
      }

      if (input.id && input.value) {
        const stateValue = dataForQB[input.id];
        if (!stateValue || stateValue !== input.value) {
          console.log(`Syncing DOM value for: ${input.id} = ${input.value}`);
          syncedCount++;
          mapToRedux(input.id, input.value);
          updateColumn2Count(input.id, input.value);
        }
      }
    });

    console.log(`Synced ${syncedCount} fields from DOM to state`);
    return syncedCount;
  };

  function runAllValidations (){
    // Sync autofilled values before validation
    const syncedCount = syncDOMValuesToState();

    // Function to check validation and provide feedback
    const checkAndProceed = () => {
      // Update the validation state
      updateColumn2Count();

      let passed = true;
      const missingFields = getMissingRequiredFields();
      const validationErrors = [];

      // Contact Phone validation
      if (assessmentState.districtContactPhone_bil && !validatePhone(assessmentState.districtContactPhone_bil)) {
        setValidation_districtPhone('*Please provide a 10 digit phone')
        validationErrors.push('District Contact Phone: must be a valid 10-digit phone number');
        passed = false;
      }
      else setValidation_districtPhone('')

      // Psychologist Email validation
      if (assessmentState.psychologistEmail_bil && !validateEmail(assessmentState.psychologistEmail_bil)) {
        setValidation_psychologistEmail('*Please provide a valid email')
        validationErrors.push('Psychologist Email: must be a valid email address');
        passed = false;
      }
      else setValidation_psychologistEmail('')

      // Speech Pathologist Email validation
      if (assessmentState.speechPathologistEmail_bil && !validateEmail(assessmentState.speechPathologistEmail_bil)) {
        setValidation_speechPathologistEmail('*Please provide a valid email')
        validationErrors.push('Speech Pathologist Email: must be a valid email address');
        passed = false;
      }
      else setValidation_speechPathologistEmail('')

      // Current Teacher Email validation
      if (assessmentState.currentTeacherEmail_bil && !validateEmail(assessmentState.currentTeacherEmail_bil)) {
        setValidate_currentTeacherEmail('*Please provide a valid email')
        validationErrors.push('Current Teacher Email: must be a valid email address');
        passed = false;
      }
      else setValidate_currentTeacherEmail('')

      // District Contact Email validation
      if (assessmentState.districtContactEmail_bil && !validateEmail(assessmentState.districtContactEmail_bil)) {
        setValidation_districtContactEmail('*Please provide a valid email')
        validationErrors.push('District Contact Email: must be a valid email address');
        passed = false;
      }
      else setValidation_districtContactEmail('')

      // Approver Email validation
      if (assessmentState.approverEmail_bil && !validateEmail(assessmentState.approverEmail_bil)) {
        setValidation_approverEmail('*Please provide a valid email')
        validationErrors.push('Approver Email: must be a valid email address');
        passed = false;
      }
      else setValidation_approverEmail('')

      if (passed && missingFields.length === 0){
        dataForQB.assessmentRunOnce = false;
        handleThisContinueButton("assessmentPage3")
      }
      else{
        // Show modal with missing fields and validation errors
        setValidationModalMissingFields(missingFields);
        setValidationModalErrors(validationErrors);
        setValidationModalOpen(true);
      }
    };

    if (syncedCount > 0) {
      console.log(`Synced ${syncedCount} autofilled fields before validation`);
      // Give a moment for state to update after sync
      setTimeout(checkAndProceed, 200);
    } else {
      // No sync needed, check immediately
      checkAndProceed();
    }
  }
  function validateEmail(email) {
    if (email=="") return true;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validatePhone(phone)
  {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if(phone.match(phoneno)) return true;
    else return false;
  }



  if (!dataForQB.assessmentRunOnce){
    dataForQB.assessmentRunOnce = true;
    setTimeout(function(){
      //updateColumn1Count();
      //updateColumn2Count();
      //alert("RUNNNING")
      checkCol2AtStart();
    },300)
      console.log(col2RequiredFields)
  }
  const checkCol2AtStart = () =>{
    col2RequiredFields["CSEDate_bil"] = dataForQB.CSEDate_bil;
    col2RequiredFields["psychologistName_bil"] = dataForQB.psychologistName_bil;
    col2RequiredFields["psychologistEmail_bil"] = dataForQB.psychologistEmail_bil;
    col2RequiredFields["speechPathologistName_bil"] = dataForQB.speechPathologistName_bil;
    col2RequiredFields["speechPathologistEmail_bil"] = dataForQB.speechPathologistEmail_bil;
    col2RequiredFields["districtContactName_bil"] = dataForQB.districtContactName_bil;
    col2RequiredFields["districtContactTitle_bil"] = dataForQB.districtContactTitle_bil;
    col2RequiredFields["districtContactAddress_bil"] = dataForQB.districtContactAddress_bil;
    col2RequiredFields["districtContactPhone_bil"] = dataForQB.districtContactPhone_bil;
    col2RequiredFields["districtContactEmail_bil"] = dataForQB.districtContactEmail_bil;
    col2RequiredFields["approverName_bil"] = dataForQB.approverName_bil;
    col2RequiredFields["approverTitle_bil"] = dataForQB.approverTitle_bil;
    col2RequiredFields["approverEmail_bil"] = dataForQB.approverEmail_bil;
    var allFilledOut = true;
    for (var key in col2RequiredFields) {
      console.log("KEY: " + key)
      if (col2RequiredFields[key] == "") {
        console.log(col2RequiredFields[key] + "FAILED")
        allFilledOut = false;
      }
      
    }
    console.log("FILLED OUT: " + allFilledOut)
    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent()
  }

  setTimeout(function(){
    updateColumn2Count();
    setProgressBarDataInParent();
  },500)
  //////////////////////////////////////////////////////////////
    // Scroll to relevant section of data entry on next page
    useEffect(() => {
      setTimeout(function(){window.scrollTo(0, 200)}, 400);
    }, []);
    //////////////////////////////////////////////////////////////
    // Mapping
    const mapToRedux = (id, valueInInput) => {
      switch (id) {
        case "CSEDate_bil":
          dispatch(CSEDate_bilUpdated(valueInInput.toISOString()))
          break;
        case "currentTeacherName_bil":
          dispatch(currentTeacherName_bilUpdated(valueInInput))
          break;
        case "currentTeacherEmail_bil":
          dispatch(currentTeacherEmail_bilUpdated(valueInInput))
          break;
        case "psychologistName_bil":
          dispatch(psychologistName_bilUpdated(valueInInput))
          break;
        case "psychologistEmail_bil":
          dispatch(psychologistEmail_bilUpdated(valueInInput))
          break;
        case "speechPathologistName_bil":
          dispatch(speechPathologistName_bilUpdated(valueInInput))
          break;
        case "speechPathologistEmail_bil":
          dispatch(speechPathologistEmail_bilUpdated(valueInInput))
          break;
        case "districtContactName_bil":
          dispatch(districtContactName_bilUpdated(valueInInput))
          break;
        case "districtDropdown_bil":
          dispatch(districtDropdown_bilUpdated(valueInInput))
          break;
        case "districtContactTitle_bil":
          dispatch(districtContactTitle_bilUpdated(valueInInput))
          break;
        case "districtContactAddress_bil":
          dispatch(districtContactAddress_bilUpdated(valueInInput))
          break;
        case "districtContactPhone_bil":
          dispatch(districtContactPhone_bilUpdated(valueInInput))
          break;
        case "districtContactEmail_bil":
          dispatch(districtContactEmail_bilUpdated(valueInInput))
          break;
        case "approverName_bil":
          dispatch(approverName_bilUpdated(valueInInput))
          break;
        case "approverTitle_bil":
          dispatch(approverTitle_bilUpdated(valueInInput))
          break;
        case "approverEmail_bil":
          dispatch(approverEmail_bilUpdated(valueInInput))
          break;
        default:
          console.log("ID not found: " + id)
      }
    }
    //////////////////////////////////////////////////////////////


  return (
    <ThemeProvider theme={useStyles}>
      <ValidationModal
        open={validationModalOpen}
        onClose={() => setValidationModalOpen(false)}
        missingFields={validationModalMissingFields}
        validationErrors={validationModalErrors}
      />

      <div className='progress-bar-container'>
          <ProgressBar 
            key={0} 
            bgcolor={"#00695c"}
            completed={assessmentState.page2ProgressBar} 
            fixedClass={progressBarClass}
            isDisabed={false}
            runAllValidations={runAllValidations}
          />
          
          <MySectionBlock 
            height="5px" 
            onEnterViewport={() => {
                console.log('enter viewportttt')
                setProgressBarClass('')
            }}
            onLeaveViewport={() => {
                console.log('leave viewportttt')
                setProgressBarClass('progressBar-fixed')
            }}
          />
      </div>

    <div>{/* className={classes.root}>*/}
      <FadeIn delay={200} duration={450}>
          <Container fluid className="">
            {/* Content */}
            <Row>
              <Row>
                <Box style={{width: '60%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
                  <Card variant="outlined" style={{padding: '10px',}}>
                    <CardContent>
                {/* Left Column */}
                <Col>
                  {/*<Row>
                      <Col>
                      <p style={{border: "1px solid black", backgroundColor: "#F8F8F8", padding: "4px", textAlign: "center"}}>DISTRICT INFORMATION</p>
                      </Col>
                  </Row>*/}
                  
                  <Row>
                      <Col>
                        <p className={"assessment-section-headers"}>
                          *Date you need this completed by
                        </p>
                      </Col>
                  </Row>
                  <Row>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px' }}>
                      <DatePicker_Simple triggerUpdateInParent={mapToRedux} id="CSEDate_bil" 
                        required={true}
                        valueInField={assessmentState.CSEDate_bil}
                        className="date-picker-main" 
                        classesToAdd={""}
                        label="CSE Date" 
                        selected={startDueDate} 
                        onChange={date => setStartDueDate(date)} />
                      </div>
                  </Row>
                  <Row>
                      <Col>
                        <p className={"assessment-section-headers"}>
                            *As per guidance from NYSED's Office of Special Education and Office of Bilingual Education and World Languages,
                            score reports will be sent only to building evaluators. Please provide contact information for the appropriate
                            psychologist and speech pathologist
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px' }}>
                            <TextFields_Outlined valueInField={assessmentState.psychologistName_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="psychologistName_bil" label="Psychologist" />
                            &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                            <TextFields_Outlined valueInField={assessmentState.psychologistEmail_bil} classesToAdd={"required-adjusted-lower"} noSpaces={true} required={true} validationText={validate_psychologistEmail} triggerUpdateInParent={mapToRedux} id="psychologistEmail_bil" label="Email" />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px' }}>
                            <TextFields_Outlined valueInField={assessmentState.speechPathologistName_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="speechPathologistName_bil" label="Speech Pathologist" />
                            &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                            <TextFields_Outlined valueInField={assessmentState.speechPathologistEmail_bil} classesToAdd={"required-adjusted-lower"} noSpaces={true} required={true} validationText={validate_speechPathologistEmail} triggerUpdateInParent={mapToRedux} id="speechPathologistEmail_bil" label="Email" />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px' }}>
                          <TextFields_Outlined valueInField={assessmentState.currentTeacherName_bil} classesToAdd={""} required={false} triggerUpdateInParent={mapToRedux} id="currentTeacherName_bil" label="Current Teacher" />
                          &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.currentTeacherEmail_bil} classesToAdd={""} noSpaces={true} required={false} validationText={validate_currentTeacherEmail} triggerUpdateInParent={mapToRedux} id="currentTeacherEmail_bil" label="Email" />
                        </div>
                      </Col>
                  </Row>
                  <Row><Col>&nbsp;</Col></Row>
                  <Row>
                      <Col>
                        <p className={"assessment-section-headers"}>
                          *Evaluation report(s) will be sent to the district contact person below.
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px' }}>
                          <TextFields_Outlined valueInField={assessmentState.districtContactName_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="districtContactName_bil" label="Contact Name" />
                          &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.districtContactTitle_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="districtContactTitle_bil" label="Contact Title" />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px' }}>
                          <TextFields_Outlined valueInField={assessmentState.districtContactPhone_bil} classesToAdd={"required-adjusted-lower"} noSpaces={true} required={true} validationText={validate_districtPhone} triggerUpdateInParent={mapToRedux} id="districtContactPhone_bil" label="Contact Phone #" />
                          &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.districtContactEmail_bil} classesToAdd={"required-adjusted-lower"} noSpaces={true} required={true} validationText={validate_districtContactEmail} triggerUpdateInParent={mapToRedux} id="districtContactEmail_bil" label="Contact Email" />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px' }}>
                          <TextFields_Outlined_Long valueInField={assessmentState.districtContactAddress_bil} classesToAdd={"long-input"} required={true} triggerUpdateInParent={mapToRedux} id="districtContactAddress_bil" label="School/Office Address" />
                        </div>
                      </Col>
                  </Row>

                  <Row><Col>&nbsp;</Col></Row>



                  <Row>
                      <Col>
                        <p className={"assessment-section-headers"}>
                          The request will be approved by
                        </p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '2px' }}>
                          <TextFields_Outlined valueInField={assessmentState.approverName_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="approverName_bil" label="Approver Name" />
                          &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.approverTitle_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="approverTitle_bil" label="Approver Title" />
                          &nbsp;&nbsp;&nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.approverEmail_bil} classesToAdd={"required-adjusted-lower"} noSpaces={true} required={true}  validationText={validate_approverEmail} triggerUpdateInParent={mapToRedux} id="approverEmail_bil" label="Approver Email" />
                        </div>
                      </Col>
                  </Row>

                  <Row><Col>&nbsp;</Col></Row>


                  
                </Col>
              </CardContent>
              </Card>
              </Box>
              </Row>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row><Col>&nbsp;</Col></Row>

            <Row>
              <Col className="col-sm-12">
              </Col>
            </Row>

          </Container>
          <div className="form-button-bottom-container">
            {/*<Button className="btn btn-primary form-button-bottom" onClick={() => backToPreviousScreen()} disabled={false}//!column1Complete || !column2Complete}
                variant="contained" color="primary">
                Back
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;*/}
            <Button className="btn btn-primary form-button-bottom" onClick={() => runAllValidations()}
              variant="contained" color="primary">
              Next Page
            </Button>
          </div>
          <br/><br/><br/><br/>
      </FadeIn>
    </div>
    </ThemeProvider>
  )
}

export default BilingualAssessmentContent
